import { useNavigate } from 'react-router-dom'

const Arrow = () => (
  <svg width="17" height="12" viewBox="0 0 17 12" fill="none">
    <path
      d="M11 1l5 5-5 5M16 6H1"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CallToAction = () => {
  const navigate = useNavigate()

  return (
    <section className="relative overflow-hidden bg-brand-dark">
      <div
        className="absolute left-[22%] top-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(76,188,24,0.20), transparent 70%)' }}
      />
      <div
        className="absolute right-[12%] top-[60%] w-[140px] h-[140px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(76,188,24,0.18), transparent 70%)' }}
      />

      {/* D1.4.2: the section measured 344px against 308 in the file, and the 36px was spread
          across every part rather than sitting in one place — so matching the total meant
          matching the parts. From the export: heading 38/48 (we had 44/52), heading→buttons 36
          (40), buttons 56, buttons→trust 16 (32), trust row 20, padding 66 (72). That sums to
          exactly 308. Desktop only; mobile is untouched. */}
      <div className="relative z-10 max-w-canvas mx-auto px-6 md:px-[120px] py-[48px] md:py-[66px] flex flex-col items-center">
        <h2 className="text-[28px] leading-[36px] md:text-[38px] md:leading-[48px] font-extrabold text-white text-center">
          Make Every Deal a{' '}
          <span className="text-brand-primary">Calculated Decision</span>
        </h2>

        <div className="mt-10 md:mt-9 w-full max-w-[320px] sm:max-w-none flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            type="button"
            onClick={() => navigate('/pricing')}
            className="w-full sm:w-auto h-[56px] px-8 rounded-full bg-white text-brand-dark text-[16px] font-semibold inline-flex items-center justify-center gap-2 hover:bg-brand-pageFill transition-colors"
          >
            View Full Pricing
          </button>
          <button
            type="button"
            onClick={() => navigate('/signup')}
            className="w-full sm:w-auto h-[56px] px-8 rounded-full bg-brand-primary hover:bg-brand-hover text-white text-[16px] font-semibold inline-flex items-center justify-center gap-2 transition-colors"
          >
            Analyze Deals Free
            <Arrow />
          </button>
        </div>

        {/* D1.4.1: one row on desktop. Mobile keeps the 2 + 1 wrap Микола asked for in
            set #1 — the row simply wraps there, which produces the same result without a
            second hand-built row. */}
        {/* 13.08 set #3 item 4: he filed the sign-up heading drop of "7-Day" and confirmed the
            other spot should follow — but only the sign-up checkmark and the trust line ever
            said "7 days"/"7-day"; this row is the equivalent home-page copy. Matches the
            sign-up checkmark's own wording exactly (Signup.jsx), not a shortened variant of it. */}
        <div className="mt-8 md:mt-4 flex flex-wrap items-center justify-center md:flex-nowrap gap-x-8 gap-y-2 text-white/85">
          {['7 days', 'Analyze up to 5 properties', 'No credit card required'].map((t) => (
            <div key={t} className="flex items-center gap-2 text-[13px] md:text-[12px] whitespace-nowrap">
              <span className="w-[20px] h-[20px] rounded-full bg-brand-primary flex items-center justify-center shrink-0">
                <svg width="10" height="8" viewBox="0 0 12 9" fill="none">
                  <path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              {t}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CallToAction
